import React, { createContext, useEffect, useState } from "react";
import { api, subscribe, ClientState, getClientState } from "./resilientAxios";

type ContextType = {
  axios: typeof api;
  activeEndpoint: string | null;
  switching: boolean;
};

export const ResilientAxiosContext = createContext<ContextType>({
  axios: api,
  activeEndpoint: null,
  switching: false
});

export const ResilientAxiosProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [state, setState] = useState<ClientState>(getClientState);

  useEffect(() => {
    const unsub = subscribe(setState);
    return unsub;
  }, []);

  return (
    <ResilientAxiosContext.Provider
      value={{
        axios: api,
        activeEndpoint: state.activeEndpoint,
        switching: state.switching
      }}
    >
      {children}
    </ResilientAxiosContext.Provider>
  );
};
